import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

function ServiceRecommendationBanner({ recommendation, onDismiss }) {
  const [isExiting, setIsExiting] = useState(false);

  /*
   * A SINGLE recommendation should have one item.
   *
   * For a CAROUSEL, this component can later render all items.
   */
  const item = recommendation?.items?.[0];

  if (!item) {
    return null;
  }

  const handleDismiss = () => {
    if (isExiting) return;

    setIsExiting(true);

    setTimeout(() => {
      if (onDismiss) {
        onDismiss();
      }
    }, 300);
  };

  /*
   * Make sure links stored without a leading slash still
   * work correctly with React Router.
   */
  const link = item.link?.startsWith("/") ? item.link : `/${item.link}`;

  return (
    <div
      style={{
        transition:
          "opacity 300ms ease-out, transform 300ms ease-out, max-height 300ms cubic-bezier(0.4, 0, 0.2, 1), margin-bottom 300ms ease-out",

        opacity: isExiting ? 0 : 1,

        transform: isExiting
          ? "scale(0.95) translateY(-8px)"
          : "scale(1) translateY(0)",

        maxHeight: isExiting ? "0px" : "600px",

        marginBottom: 0,

        overflow: "hidden",

        pointerEvents: isExiting ? "none" : "auto",
      }}
    >
      <div className="service-recommendation-banner-container">
        <button
          type="button"
          className="banner-close-btn"
          onClick={handleDismiss}
          aria-label="Close"
        >
          <img
            src={`${process.env.PUBLIC_URL}/images/icons/close_menu_black.svg`}
            alt="Close"
          />
        </button>

        {item.image && (
          <div className="banner-image">
            <img src={item.image} alt={item.title} />
          </div>
        )}

        <div className="banner-content">
          <h4 className="margin-reset padding-reset">{item.title}</h4>

          <p style={{ lineHeight: "130%" }}>{item.description}</p>

          <div>
            <Link to={link} className="cta-button secondary small rounded">
              {item.cta_label}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

ServiceRecommendationBanner.propTypes = {
  recommendation: PropTypes.shape({
    id: PropTypes.number.isRequired,

    service: PropTypes.string.isRequired,

    display_type: PropTypes.string.isRequired,

    items: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        title: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        image: PropTypes.string,
        cta_label: PropTypes.string.isRequired,
        link: PropTypes.string.isRequired,
      }),
    ).isRequired,
  }),

  onDismiss: PropTypes.func,
};

export default ServiceRecommendationBanner;
